import { CancelablePromise, OpenAPI, type Response } from "@/api";
import { request as __request } from "@/api/core/request";
import { ListRequest } from "@/api/models/ListRequest";
import { ToDeleteRequest } from "@/utils/slice";
import { PostalAddRequest } from "@/api/models/postal/PostalAddRequest";
import { PostalUpdateRequest } from "@/api/models/postal/PostalUpdateRequest";
import { PostalListResponse } from "@/api/models/postal/PostalListResponse";
import { PostalGetRequest } from "@/api/models/postal/PostalGetRequest";
import { PostalResponse } from "@/api/models/postal/PostalResponse";

export class PostalService {
  public static Add(body: PostalAddRequest): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/admin/postal",
      body: body,
    });
  }

  public static ListAll(
    body: ListRequest
  ): CancelablePromise<PostalListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/postal",
      body: body,
    });
  }

  public static Update(body: PostalUpdateRequest): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/admin/postal",
      body: body,
    });
  }

  public static Delete(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/postal",
      body: ToDeleteRequest(body),
    });
  }

  public static Drop(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/postal/drop",
      body: ToDeleteRequest(body),
    });
  }

  public static Get(body: PostalGetRequest): CancelablePromise<PostalResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/postal/get",
      body: body,
    });
  }
}
